module.exports = __webpack_public_path__ + "img/general-english-en.af336e47.png";